// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b5-0";
export var orangeButton = "_b5-1";